import React from 'react'
import { useAuthFlow } from '../../hooks/useAuthFlow'
import EmailStep from './EmailStep'
import OtpStep from './OtpStep'
import RegisterStep from './RegisterStep'

export default function AuthFlow({ onSuccess, onClose }) {
  const { step, email, loading, error, submitEmail, submitOtp, submitRegister, reset } =
    useAuthFlow({ onSuccess })

  const titles = {
    email: 'Inloggen / Aanmelden',
    otp: 'Inlogcode invoeren',
    register: 'Aanmelden',
    unverified: 'Email niet geverifieerd',
    registered: 'Aanmelding ontvangen',
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">{titles[step]}</h2>
        {step === 'email' && (
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
            Al lid? Log in. Nog niet aangemeld? We maken direct een account voor je.
          </p>
        )}
      </div>

      {step === 'email' && (
        <EmailStep loading={loading} error={error} onSubmit={submitEmail} />
      )}

      {step === 'otp' && (
        <OtpStep email={email} loading={loading} error={error} onSubmit={submitOtp} onBack={reset} />
      )}

      {step === 'register' && (
        <RegisterStep email={email} loading={loading} error={error} onSubmit={submitRegister} onBack={reset} />
      )}

      {step === 'unverified' && (
        <div className="bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-200 dark:border-yellow-800 rounded-md p-4 space-y-3">
          <p className="text-sm text-yellow-700 dark:text-yellow-300">
            Je account is nog niet geverifieerd. Check je email voor de verificatielink.
          </p>
          <button onClick={reset} className="btn btn-outline w-full">Ander emailadres proberen</button>
        </div>
      )}

      {step === 'registered' && (
        <div className="space-y-4">
          <div className="bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800 rounded-md p-4">
            <p className="text-sm text-green-700 dark:text-green-300">
              Gelukt! We hebben een verificatiemail gestuurd naar <strong>{email}</strong>.
              Klik op de link om je aanmelding te bevestigen.
            </p>
          </div>
          {onClose && (
            <button onClick={onClose} className="btn btn-primary w-full">Sluiten</button>
          )}
        </div>
      )}
    </div>
  )
}
